import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 17a4 4 0 1 0 8 0","key":"svg-0"}],["path",{"d":"M3 16a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-1"}],["path",{"d":"M7 7a4 4 0 1 0 8 0a4 4 0 1 0 -8 0","key":"svg-2"}],["path",{"d":"M7 7c0 3 2 5 2 9","key":"svg-3"}],["path",{"d":"M15 7c0 4 -2 6 -2 10","key":"svg-4"}]]

const IconZodiacLeo = createReactComponent('outline', 'zodiac-leo', 'ZodiacLeo', __iconNode);

export default IconZodiacLeo;